<template>
  <div class>
    <STable ref="tableref" :url="url" :columns="columns" :handles="handles" :query="query" :toolbar="toolbar" />
    <el-dialog
      v-if="userDialogVisible"
      v-dialogDrag
      title="标签成员"
      :visible.sync="userDialogVisible"
      :close-on-click-modal="false"
      :before-close="closeDialog"
      width="80%"
      top="10vh"
      center
    >
      <STable
        ref="userListRef"
        :url="userUrl"
        :columns="userColumns"
        :handles="userHandles"
        :query="userQuery"
        :toolbar="userToolbar"
        :selection="false"
        label-width="80px"
      />
    </el-dialog>

    <el-dialog
      v-if="stationDialogVisible"
      v-dialogDrag
      title="标签成员"
      :visible.sync="stationDialogVisible"
      :close-on-click-modal="false"
      :before-close="closeDialog"
      width="80%"
      top="10vh"
      center
    >
      <STable
        ref="stationListRef"
        :url="stationUrl"
        :columns="stationColumns"
        :handles="stationHandles"
        :query="stationQuery"
        :toolbar="stationToolbar"
        :selection="false"
        label-width="80px"
      />
    </el-dialog>
  </div>
</template>

<script>
import Constant from '@/utils/crmConstant.json'
import { HOST } from '@/utils/host'
import { regionData, provinceAndCityData } from 'element-china-area-data'

export default {
  name: 'TagManager',
  data() {
    return {
      constant: Constant,
      userDialogVisible: false, // 标签成员弹窗
      stationDialogVisible: false, // 标签成员弹窗
      id: '',
      url: '/user/label/page',
      query: [
        {
          label: '标签名称',
          prop: 'name',
          placeholder: '请输入标签名称'
        }, {
          label: '标签类型',
          prop: 'type',
          placeholder: '请选择标签类型',
          type: 'select',
          data: Constant.tag.type
        }, {
          label: '创建时间',
          prop: 'createTime',
          placeholder: '',
          type: 'date2'
        }, {
          label: '移动端可见',
          prop: 'visible',
          placeholder: '请选择移动端可见',
          type: 'select',
          data: [
            {
              value: 1,
              label: '可见'
            },
            {
              value: 0,
              label: '不可见'
            }
          ]
        }
      ],
      columns: [
        {
          label: '标签名称',
          prop: 'name'
        },
        {
          label: '标签类型',
          prop: 'type',
          template: (index, record) => {
            return record.type === '0' ? '数据标签' : '优先级标签'
          }
        },
        {
          label: '绑定数据类型',
          prop: 'dataType',
          template: (index, record) => {
            return record.dataType === '0' ? '用户' : '电站'
          }
        },
        {
          label: '移动端可见',
          prop: 'visible',
          template: (index, record) => {
            return record.visible === '0' ? '不可见' : record.visible === '1' ? '可见' : '--'
          }
        },
        {
          label: '优先级',
          prop: 'priority',
          template: (index, record) => {
            return record.priority || '--'
          }
        },
        {
          label: '标签成员',
          prop: 'accountNumber'
        },
        {
          label: '创建人',
          prop: 'creator'
        },
        {
          label: '创建时间',
          prop: 'createTime'
        }
      ],
      toolbar: [
        {
          label: '新增',
          permission: 'user.tag.add',
          type: 'primary',
          before: (index, record) => {
            this.$router.push({
              path: 'addTag'
            })
          }
        }
      ],
      handles: {
        width: 200,
        btns: [
          {
            label: '标签成员',
            permission: 'user.tag.list',
            type: 'primary',
            before: (index, record) => {
              if (record.dataType === '0') {
                this.userDialogVisible = true
                this.id = record.id
                this.userUrl = this.userUrl + '?id=' + record.id
              } else {
                this.stationDialogVisible = true
                this.id = record.id
                this.stationUrl = this.stationUrl + '?id=' + record.id
              }
            }
          },
          {
            label: '修改',
            permission: 'user.tag.update',
            before: (index, record) => {
              this.$router.push({
                path: 'modifyUserTag',
                query: {
                  data: record
                }
              })
            },
            handle: resp => {}
          },
          {
            label: '删除',
            permission: 'user.tag.delete',
            url: '/user/label',
            method: 'delete',
            isConfirm: true,
            before: (index, record) => {
              return {
                id: record.id,
                dataType: record.dataType
              }
            },
            handle: () => {
              this.$refs.tableref.queryTable()
            }
          }
        ]
      },
      userUrl: '/user/label/userList',
      userQuery: [
        {
          label: '所属企业',
          prop: 'orgName',
          placeholder: '请输入企业名称'
        },
        {
          label: '用户账号',
          prop: 'loginName',
          placeholder: '请输入用户账号'
        },
        {
          label: '用户姓名',
          prop: 'username',
          placeholder: '请输入用户姓名'
        },
        {
          label: '用户类型',
          prop: 'type',
          placeholder: '请选择用户类型',
          type: 'select',
          data: [{
            label: '企业用户',
            value: '1'
          }, {
            label: '非企业用户',
            value: '0'
          }]
        },
        {
          label: '手机号',
          prop: 'mobile',
          placeholder: '请输入手机号'
        },
        {
          label: '车牌号',
          prop: 'carNumber',
          placeholder: '请输入车牌号'
        },
        {
          label: '用户状态',
          prop: 'status',
          placeholder: '请选择用户状态',
          type: 'select',
          data: [{
            label: '正常',
            value: 0
          }, {
            label: '冻结',
            value: 1
          }]
        },
        {
          label: '注册时间',
          prop: 'registerTime',
          placeholder: '',
          type: 'date2'
        }
      ],
      userColumns: [
        {
          label: '所属企业',
          prop: 'orgName'
        },
        {
          label: '用户账号',
          prop: 'loginName'
        },
        {
          label: '用户姓名',
          prop: 'username'
        },
        {
          label: '车牌号',
          prop: 'carNumber'
        },
        {
          label: '用户类型',
          prop: 'type'
        },
        {
          label: '手机号',
          prop: 'mobile'
        },
        {
          label: '状态',
          prop: 'status'
        },
        {
          label: '注册时间',
          prop: 'registerTime'
        },
        {
          label: '标签绑定时间',
          prop: 'bindTime'
        }
      ],
      userHandles: {},
      userToolbar: [
        {
          label: '导出',
          icon: 'el-icon-download',
          permission: 'user.tag.list.export',
          type: 'primary',
          before: (index, record) => {
            const url = HOST + '/user/label/export'
            const data = this.$refs.userListRef.getQueryData()
            $.fileDownload(url, {
              httpMethod: 'GET',
              data: {
                token: window.localStorage.getItem('token'),
                id: this.id,
                ...data
              },
              failCallback: (html, url) => {
                this.$notify({
                  title: '失败',
                  message: '导出用户列表失败',
                  type: 'error'
                })
              }
            })
          }
        }
      ],
      stationUrl: '/user/label/stationList',
      stationQuery: [
        {
          label: '电站名称',
          prop: 'stationName',
          placeholder: '请输入电站名称'
        },
        {
          label: '归属运营商',
          prop: 'operatorName',
          placeholder: '请输入运营商'
        },
        {
          label: '区域',
          prop: 'cityName',
          placeholder: '请选择区域',
          data: regionData,
          props: { checkStrictly: true, value: 'value' },
          type: 'cascader'
        }
      ],
      stationColumns: [
        {
          label: '充电站名称',
          prop: 'stationName'
        },
        {
          label: '充电站地址',
          prop: 'address'
        },
        {
          label: '运营商',
          prop: 'operatorName'
        },
        {
          label: '区划',
          prop: 'areaCode'
        },
        {
          label: '充电次数',
          prop: 'chargeCount'
        },
        {
          label: '启停状态',
          prop: 'stationStatus'
        }
      ],
      stationHandles: {},
      stationToolbar: [
        {
          label: '导出',
          icon: 'el-icon-download',
          permission: 'user.tag.list.export',
          type: 'primary',
          before: (index, record) => {
            const url = HOST + '/user/label/export'
            const data = this.$refs.stationListRef.getQueryData()
            $.fileDownload(url, {
              httpMethod: 'GET',
              data: {
                token: window.localStorage.getItem('token'),
                id: this.id,
                ...data
              },
              failCallback: (html, url) => {
                this.$notify({
                  title: '失败',
                  message: '导出电站列表失败',
                  type: 'error'
                })
              }
            })
          }
        }
      ]
    }
  },
  beforeMount() {
    this.$store.dispatch('login/getCur')
  },
  methods: {
    closeDialog() {
      this.stationDialogVisible = false
      this.userDialogVisible = false
      this.id = ''
      this.userUrl = '/user/label/userList'
      this.stationUrl = '/user/label/stationList'
    }
  } // 如果页面有keep-alive缓存功能，这个函数会触发

}
</script>

<style lang="less" src="" scoped>
  /deep/.el-dialog--center{
    padding-bottom: 50px;
  }
</style>



// WEBPACK FOOTER //
// src/views/discount/TagManager.vue